export default {
  GET_CUSTOMER_GROUP_ID_QUERY: Symbol.for('GET_CUSTOMER_GROUP_ID_QUERY'),
  GROUP_REPOSITORY: Symbol.for('GROUP_REPOSITORY'),
};
